var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0828 4.7909H3.76285C3.38439 4.7909 3.07786 4.46119 3.07786 4.0541C3.07786 3.64702 3.38439 3.31731 3.76285 3.31731H20.2026C20.5811 3.31731 20.8876 2.98759 20.8876 2.58051C20.8876 1.35973 19.9676 0.370117 18.8327 0.370117H3.07786C1.56445 0.370117 0.337891 1.68945 0.337891 3.31731V18.0533C0.337891 19.6811 1.56445 21.0004 3.07786 21.0004H20.0828C21.2824 21.0004 22.2576 20.009 22.2576 18.7901V7.00129C22.2576 5.78236 21.2824 4.7909 20.0828 4.7909ZM18.1477 14.3693C17.3912 14.3693 16.7777 13.7094 16.7777 12.8957C16.7777 12.082 17.3912 11.4221 18.1477 11.4221C18.9042 11.4221 19.5177 12.082 19.5177 12.8957C19.5177 13.7094 18.9042 14.3693 18.1477 14.3693Z",
    fill: "url(#paint0_linear_747_37466)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_747_37466",
    x1: 22.2576,
    y1: 21.0004,
    x2: -1.48356,
    y2: 18.6326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.3df297739b90b5511ac10687b6ca99a0.svg";
export { ForwardRef as ReactComponent };